import { ImageAspectRatio } from '../../types/image/image-aspect-ratio.type';

export class ImageDimensions {
    constructor(
        public w: number,
        public h: number,
        /** @deprecated Nothing reads this; `w` and `h` already encode the ratio. Removed in the next major. */
        public ar?: ImageAspectRatio
    ) {}

    toString() {
        return `${this.w}x${this.h}`;
    }
}
